import { Component, OnInit,Input, Output,EventEmitter } from '@angular/core';
import { ResultAlertError } from '@app/enums/errors.enum';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {PassengerService} from '@app/services/micro/passenger.service';
import {GlobalsService} from "@services/micro/globals.service";
import {Passenger} from '@app/models/micro/passenger.model';
import {Router} from "@angular/router";
@Component({
    selector: 'app-verify-passport-modal',
    templateUrl: './verify-passport-modal.component.html',
    styleUrls: ['./verify-passport-modal.component.scss'],
    standalone: false
})
export class VerifyPassportModalComponent implements OnInit {
  @Input() public titleError: string = '';
  @Input() public msgError: string = '';
  @Input() public codeError: string = '';
  @Input() public uuidError: string = '';
  @Input() public printCard: string = '';
  @Input() public backgroundColorModal: string = 'am-blue-premium';
  @Input() public showButton: boolean = true;
  @Input() public buttonCopy: string = '';
  @Input() public showIconImage: boolean = true;
  @Input() public urlIconImage: string = '';
  @Input() public colorFontButton: string = '';
  @Input() public backGroundButton: string = '';
  @Input() public sizeModal: string = '';
  @Input() public fontWeightTitleError: string = '';
  @Input() public image: string = '';
  @Input() public showCancelButton = false;
  @Input() public cancelButtonText ='';
  passengerSelected: Passenger[]
  currentPassenger: Passenger;
  passengers: Array<Passenger> = [];
  noPassPnr: number;
  noPassSele: number;
  isAllPass:boolean = false;

  constructor(
    private modalService: NgbActiveModal,
    private _passengerService: PassengerService,
    private global: GlobalsService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.passengerSelected = this._passengerService.getPassengerSelection();
    this.noPassPnr = this.global.reservation.passengers.length;
    this.noPassSele = this._passengerService.getPassengerSelection().length;

    if(this.noPassPnr == this.noPassSele){
      this.isAllPass = true;
    }
  }

  actionBtn() {
    this.modalService.close({operation: ResultAlertError.ACCEPT})
    //this.router.navigate(['/choose-passagers'])
    this.global.isFlowVeryPassport = true;
    this.router.navigate(['/verify-passport']);
  }

  actionBtnCancel(){
    this.modalService.dismiss();
  }

}

